import { send_request } from '../utils/Request';

export const createV2Table = (tableName, columns) =>
  send_request('data-service/v2/table', { tableName, columns }, '', 'POST');

export const getV2Tables = () =>
  send_request('data-service/v2/table', '', '', 'GET');

export const getV2Table = (tableId) =>
  send_request(`data-service/v2/table/${tableId}`, '', '', 'GET');

export const deleteV2Table = (tableId) =>
  send_request(`data-service/v2/table/${tableId}`, '', '', 'DELETE');

export const renameV2Table = (tableId, tableName) =>
  send_request(`data-service/v2/table/${tableId}`, { tableName }, '', 'PUT');

export const addV2Column = (tableId, columnName, type) =>
  send_request(`data-service/v2/table/${tableId}/column`, { columnName, type }, '', 'POST');

export const renameV2Column = (tableId, columnId, newName) =>
  send_request(`data-service/v2/table/${tableId}/column/${columnId}`, { newName }, '', 'PUT');

export const deleteV2Column = (tableId, columnId) =>
  send_request(`data-service/v2/table/${tableId}/column/${columnId}`, '', '', 'DELETE');

export const createV2Row = (tableId, values) =>
  send_request(`data-service/v2/table/${tableId}/row`, { values }, '', 'POST');

export const createV2RowsBatch = (tableId, rows) =>
  send_request(`data-service/v2/table/${tableId}/rows/batch`, { rows }, '', 'POST');

export const updateV2Row = (tableId, rowId, values) =>
  send_request(`data-service/v2/table/${tableId}/row/${rowId}`, { values }, '', 'PUT');

export const deleteV2Row = (tableId, rowId) =>
  send_request(`data-service/v2/table/${tableId}/row/${rowId}`, '', '', 'DELETE');

export const getV2Rows = (tableId, page = 0, pageSize = 100, sortColumn = null, sortDirection = null) => {
  let url = `data-service/v2/table/${tableId}/rows?page=${page}&pageSize=${pageSize}`;
  if (sortColumn) url += `&sortColumn=${encodeURIComponent(sortColumn)}`;
  if (sortDirection) url += `&sortDirection=${encodeURIComponent(sortDirection)}`;
  return send_request(url, '', '', 'GET');
};

export const queryV2Table = (tableId, query) =>
  send_request(`data-service/v2/table/${tableId}/query`, query, '', 'POST');

// Phase 5 - not yet implemented on the backend
export const migrateToV2 = (_databaseId) =>
  Promise.reject(new Error('Migration endpoint not yet implemented (Phase 5)'));

export const duplicateToV2 = (databaseId) =>
  send_request(`data-service/v2/duplicate/${databaseId}`, '', '', 'POST');
